export default "__VITE_ASSET__BJCqLeE8__"